import { render, staticRenderFns } from "./PayPal.vue?vue&type=template&id=4082ef81&scoped=true&"
import script from "./PayPal.vue?vue&type=script&lang=js&"
export * from "./PayPal.vue?vue&type=script&lang=js&"
import style0 from "./PayPal.vue?vue&type=style&index=0&id=4082ef81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4082ef81",
  null
  
)

export default component.exports